// @flow

import * as React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Loader from '../Preloader';

import './styles.scss';
// import Checkbox from '../Checkbox';

import Columns from './Columns';
import Pagination from './Pagination';

type Props = {
  coin?: string,
  data: Array<any>,
  col: any,
  loading: boolean,
  manual?: boolean,
  onFetchData?: (any) => void,
  handleRow?: (any) => void,
  pages: number,
  // pageSize: number,
  defaultPageSize: number,
};

export default ({
  coin = '',
  data,
  col,
  onFetchData,
  pages,
  // pageSize,
  defaultPageSize,
  handleRow,
  manual = false,
  loading,

}: Props) => {
  const columns = new Columns(col, coin);
  const noDataInfo = () => {
    // eslint-disable-next-line no-underscore-dangle
    const _loading = loading ? <Loader size={50} /> : null;
    return <div className="table-loader">{_loading}</div>;
  };

  const int = () => {
    // eslint-disable-next-line radix
    if (parseInt(pages) === pages) {
      return pages;
    }
    return Math.trunc(pages) + 1;
  };

  React.useEffect(() => {
    int();
  }, []);

  return (
    <ReactTable
      data={data}
      PaginationComponent={Pagination}
      manual={manual}
      // manualSortBy
      // filterable
      // onSortedChange={onSortedChange}
      // showPagination
      resizable
      onFetchData={onFetchData}
      columns={columns}
      defaultPageSize={defaultPageSize}
      // showPaginationTop
      // showPaginationBottom={false}
      NoDataComponent={noDataInfo}
      noDataInfo="no data"
      className="-striped -highlight"
      // pageSize={pageSize}
      pages={int() || 0}
      getTrProps={(states, rowInfo) => ({
        onClick: (e, handleOriginal) => {
          // eslint-disable-next-line no-unused-expressions
          if (handleRow) {
            handleRow(rowInfo);
          }
          if (handleOriginal) {
            handleOriginal();
          }
        },
        'at-id': `card_id_${rowInfo?.original?.id ?? 'none'}`,
      })}
      // pages={pages }
      // manual
    />
  );
};
